<template>
	<div>
		<div class="display-1 font-weight-light mb-3">Existing Partners</div>

		<v-text-field
			v-show="inviteLink"
			label="Invite Link"
			readonly
			outlined
			success
			color="success"
			:value="inviteLink"
			prepend-icon="far fa-copy clickable"
			class="link-input"
		></v-text-field>

		<v-simple-table v-if="partners.length > 0 && !loading" class="mt-3">
			<thead>
			<tr>
				<th class="column text-left">Name</th>
				<th class="column text-left">Description</th>
				<th class="column text-left"></th>
				<th class="column text-left"></th>
				<th class="column text-left"></th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="p in partners" :key="p.id">
				<td>{{p.name}}</td>
				<td>{{p.description}}</td>
				<td><v-btn text color="primary" :to="{name: 'applications', params: { id: p.id }}">Applications</v-btn></td>
				<td><v-btn text color="primary" @click="invite(p.id)">Invite</v-btn></td>
				<td><v-btn text color="warning" @click="deletePartner(p.id)">Delete</v-btn></td>
			</tr>
			</tbody>
		</v-simple-table>
		<v-alert
			v-if="partners.length === 0 && !loading"
			type="info"
		>
			There are no Partners. Create one below
		</v-alert>
		<v-alert
			v-if="loading"
			type="info"
			icon="fa-spin fa-spinner"
		>
			Loading
		</v-alert>

		<add-partner @add="refresh" />
	</div>
</template>

<script>
import ClipBoard from "clipboard";
import analysisApi from "../analysisApi";
import AddPartner from "../components/partners/partners-add.vue";
import { actionTypes } from "../store-types";

export default {
	components: {
		AddPartner,
	},
	data() {
		return {
			loading: true,
			partners: [],
			inviteLink: null,
			clipboard: null,
		};
	},
	created() {
		this.refresh();
	},
	mounted() {
		this.clipboard = new ClipBoard(".fa-copy", {
			target: () => document.querySelectorAll(".link-input input")[0],
		});

		this.clipboard.on("success", () => {
			this.showToast("success", "Link Copied");
		});
	},
	beforeDestroy() {
		this.clipboard.destroy();
	},
	methods: {
		deletePartner(id) {
			analysisApi.deletePartner(id)
				.then(() => {
					this.refresh();
					this.$store.dispatch(actionTypes.LOAD_CONFIG);
					this.showToast("success", "Partner Deleted");
				})
				.catch((e) => {
					this.showError(e);
				});
		},
		invite(id) {
			analysisApi.generateInviteLinkForPartner(id)
				.then((r) => {
					this.inviteLink = `${window.location.origin}/register/${r.data}`;
				})
				.catch((e) => {
					this.showError(e);
				});
		},
		refresh() {
			analysisApi.existingPartners()
				.then((r) => {
					this.partners = r.data;
					this.loading = false;
				})
				.catch((e) => {
					this.showError(e);
					this.loading = false;
				});
		},
	},
};
</script>
